define('views/modules/member/group/group-content',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'src/routes',
    // services
    'services/i18n',
    'services/user',
    'services/events/user-events',
    // collections
    'models/member/group',
    'collections/member/groups',
    // views
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-action',
    'views/parts/menu/menu-dropdown',
    'views/parts/form/textbox',
    'views/modules/member/group/lists/group-list',
    'views/modules/member/group/group-lists-controller',
    'views/modules/member/group/edit/group-edit-panel',
    'views/parts/alert/alert-no-data',
    // templates
    'text!templates/modules/member/group/group-content.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U, Routes,
    // services
    i18n,
    User,
    UserEvents,
    // collections
    MGroup,
    CGroups,
    // views
    VTreeView,
    VMenuAction,
    VMenuDropdown,
    VTextBox,
    VGroupList,
    VGroupListsController,
    VGroupEditPanel,
    VAlertNoData,
    // templates
    TGroupBlock
) {

    var VGroupBlock = Backbone.View.extend({
        template: TGroupBlock,
        // events: {
        // },
        regions: {
            root: "#group",
            menu: ".menu-actions",
            search: ".search-placeholder",
            groups: "#group-menu",
            add: {
                elem: "#add-group",
                form: "#add-group-form",
            },
            list: "#group-list",
            alert: '.alert-no-data'
        },

        events: {
            "click .close": "onCloseAddGroupForm",
        },

        initialize: function(opt) {

              _.extend(this, {
                 panel: {}
             });

            this.groupCollection = new CGroups(null, { tree: true, tree_only: true, removeExpired: false });

            // Actions menu
            this.actionCollection = new Backbone.Collection([
                { route: '#', title: i18n.t('messages:tooltip-add-group'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddGroupAction },
            ]);

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    radio: false,
                    collection: this.actionCollection,
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                list: new VGroupListsController({
                    title: "Groups",
                    icon: "sl-icon-layers",
                    collection: this.groupCollection,
                }),
                alert: new VAlertNoData({
                    title: "no-subgroups-title",
                    subtitle: "no-subgroups-subtitle",
                    addClass: 'alert-arrow alert-arrow-left-top',
                    collection: new Backbone.Collection()
                })
            };


            this.listenTo(UserEvents, { "group:editGroup": this.onGroupClick });
            this.listenTo(UserEvents, { "group:modify": this.onGroupModify });
            this.listenTo(this.groupCollection, { "sync": this.onGroupCollectionSync });

        },

        render: function() {
            this.groupCollection.fetch();

            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);

            this.generateZones()
                .assign(this.view.menu, this.zone.$menu)
                .assign(this.view.list, this.zone.$list)
                .assign(this.view.alert, this.zone.$alert)
                .renderAddForm();

            return this;
        },

        renderAddForm: function() {
            // lazy render
            if (this.view.add) {
                this.assign(this.view.add, this.zone.add.$form);
            }

        },

        toggleAddForm: function(val) {
            this.zone.add.$elem.toggle(val);
        },

        updateGroupCollection: function() {
            this.groupCollection.reset(this.selectedGroup.profiles.models);
            var foundModel = this.groupCollection.findWhere({ _id: this.model.id });
            if (foundModel) {
                this.model = foundModel;
            }
            this.list.reset(this.groupCollection.where({ _isExpired: false, _isPending: false }));
        },

        /////////////
        // actions //
        /////////////
        onActionClicked: function(e, actionModel) {
            e.preventDefault();
        },

        onSearchAction: function(e, itemModel) {
            if (itemModel.get('active')) {
                this.zone.$search.fadeIn(300);
            } else {
                this.zone.$search.fadeOut(300);
            }
        },

        onAddGroupAction: function(e, itemModel) {
          e.preventDefault();
          var newGroup = new MGroup();
          var panel = this.lazyInit(newGroup);
          panel.setModel(newGroup);
          this.trigger('panel:stack', panel);
        },

        lazyInit: function(groupModel) {
              var view = this.panel.edit;
              if (!view) {
                  view = this.panel.edit = new VGroupEditPanel({ model: groupModel, collection: this.groupCollection });
                  this.listenTo(view, 'form:success', this.onGroupUpdate);
              }
              return view;
        },
        ////////////
        // events //
        ////////////

        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.at(0));
            }
        },

        onSelectGroup: function(groupModel) {

            if (groupModel !== undefined && this.selectedGroup !== groupModel) {
                if (this.selectedGroup) {
                    this.selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = groupModel;

                this.selectedGroup.profiles.fetch({
                    context: this,
                    success: this.updateGroupCollection
                });
            }

            this.view.groups.setLabel(this.selectedGroup.get('name'));
            this.selectedGroup.set('_menuActive', true);
        },

        onCloseAddGroupForm: function(e) {
            this.toggleAddForm(false);
        },

        onNewGroupSaved: function(model) {
            if (!model.isNew()) {
                this.stopListeningTo(model);
                this.toggleAddForm(false);

                this.groupCollection.add(model.clone());
            }

        },

        onShowAllGroup: function() {},
        onGroupUpdate: function() {},
        onGroupManage: function() {},

        onGroupModify: function(group, collection) {
            this.view.list.render();
        },

        onGroupClick: function(groupModel, e) {
          e.preventDefault();
          var panel = this.lazyInit(groupModel);
          panel.setModel(groupModel);
          this.trigger('panel:stack', panel);
        },

        onGroupCollectionSync: function() {
            var subgroups = this.groupCollection.findWhere({ _id: User.getMainGroupId() }).get('subgroups').models;
            this.view.alert.setCollection(new Backbone.Collection(subgroups));
            this.view.alert.toggleAlert();
        }

    });

    return VGroupBlock;

});

